import Icon from '../components/Icon.vue'

Icon.register({
  menorah: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M144 128c8.8 0 16 7.2 16 16v144h-64v-144c0-8.8 7.2-16 16-16h32zM240 128c8.8 0 16 7.2 16 16v144h-64v-144c0-8.8 7.2-16 16-16h32zM432 128c8.8 0 16 7.2 16 16v144h-64v-144c0-8.8 7.2-16 16-16h32zM528 128c8.8 0 16 7.2 16 16v144h-64v-144c0-8.8 7.2-16 16-16h32zM608 96c-17.7 0-32-14.3-32-32s32-64 32-64 32 46.3 32 64-14.3 32-32 32zM512 96c-17.7 0-32-14.3-32-32s32-64 32-64 32 46.3 32 64-14.3 32-32 32zM416 96c-17.7 0-32-14.3-32-32s32-64 32-64 32 46.3 32 64-14.3 32-32 32zM320 96c-17.7 0-32-14.3-32-32s32-64 32-64 32 46.3 32 64-14.3 32-32 32zM224 96c-17.7 0-32-14.3-32-32s32-64 32-64 32 46.3 32 64-14.3 32-32 32zM128 96c-17.7 0-32-14.3-32-32s32-64 32-64 32 46.3 32 64-14.3 32-32 32zM32 96c-17.7 0-32-14.3-32-32s32-64 32-64 32 46.3 32 64-14.3 32-32 32zM576 288v-144c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v144c0 53-43 96-96 96h-192v64h176c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-416c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h176v-64h-192c-53 0-96-43-96-96v-144c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v144c0 17.7 14.3 32 32 32h192v-176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v176h192c17.7 0 32-14.3 32-32z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/menorah.js
// module id = 1560
// module chunks = 0